module.exports = __webpack_public_path__ + "img/flexible_technological_turbine.13c4ee99.svg";